import thunkMiddleware from "redux-thunk";
import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import Reducer from "./reducers/reducer";

export const store = createStore(Reducer, composeWithDevTools(applyMiddleware(thunkMiddleware)));
